import { cn } from '@/shared/lib/utils/cn';
import { Tag, Text } from '@/shared/ui';

type Props = {
  prompt: string;
  tagLabel?: string;
  onClick?: () => void;
};

/**
 * おすすめの質問カード（クリックで親に質問テキストを通知）
 * 初期状態は全カード白、ホバー時に AI グラデーション + アクセント色に切り替わる
 */
export const SuggestedQuestionCard = ({ prompt, tagLabel, onClick }: Props) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      'group flex h-full cursor-pointer flex-col items-start gap-2 rounded-xl border border-border-base bg-surface-base p-4 text-left shadow-xs transition-colors',
      'hover:border-primary/60 hover:bg-linear-to-r hover:from-brand-50 hover:to-brand-100',
    )}
  >
    <Text
      variant="label"
      className="cursor-pointer whitespace-normal text-left font-normal transition-colors group-hover:text-text-accent"
    >
      {prompt}
    </Text>
    {tagLabel && <Tag size="small">{tagLabel}</Tag>}
  </button>
);
